import { purple } from "@mui/material/colors";
import { QueryClient } from "@tanstack/react-query";
import { bwDarkTheme, RaThemeOptions } from "react-admin";

export enum ResourceName {
  USERS = "users",
  ADMIN_USERS = "admin-users",
  VETTING_USERS = "vetting-users",
  AFFILIATE_USERS = "affiliate-users",
  REFERRAL_USERS = "referral-users",
  AFFILIATE_PAYOUTS = "affiliate-payouts",
  USER_PURCHASES = "user-purchases",
  SUPPORT = "support",
  USERS_ANALYTICS = "users-analytics",
  EVENTS = "events",
}

export const theme: RaThemeOptions = {
  ...bwDarkTheme,
  palette: {
    ...bwDarkTheme.palette,
    secondary: {
      ...bwDarkTheme.palette?.secondary,
      main: purple[800],
    },
  },
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retryDelay: 10000,
      onError: () => {},
    },
  },
});
